import React from "react";
import { AccordianNew } from "../../../../../components";
import AccrdianL1Tabledata from "./AccrdianL1Tabledata";
const data = [
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
      ],
    },
    _id: "683ac70f65e030001d60551c",
    uiid: 10001,
    firstName: "shiva",
    lastName: "shiva",
    employmentType: 2,
  },
  {
    approvalFlow: {
      delegatedTo: [
        102, 120, 9996, 9997, 9997, 9996, 9997, 9996, 9993, 9995, 9989, 9994,
        9988, 9986, 9985, 9983,
      ],
      approverTo: [
        {
          _id: "baff1124a54b200be606beb0",
          uiid: 10000,
          firstName: "margaret",
          lastName: "mraz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          _id: "4940a325d6a5df1a35d2ea20",
          uiid: 198,
          firstName: "kelton",
          lastName: "anderson",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
      ],
    },
    _id: "baff1124a54b200be606beb0",
    uiid: 10000,
    firstName: "margaret",
    lastName: "mraz",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [
        164, 188, 9997, 9996, 9995, 9994, 9995, 9994, 9993, 9989, 9988, 9986,
        9985, 9983, 9997, 9996, 9995, 10013, 10012, 10011, 10010, 10009, 10008,
        10007, 10006, 10005, 10004,
      ],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "80e4f75ef54478d2d3e7d1c8",
          uiid: 170,
          firstName: "cleve",
          lastName: "howell",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e6276921b815a703651",
          uiid: 10010,
          firstName: "john6",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e5976921b815a70364e",
          uiid: 10009,
          firstName: "john5",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e4e76921b815a70364b",
          uiid: 10008,
          firstName: "john4",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e4176921b815a703648",
          uiid: 10007,
          firstName: "john3",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e3676921b815a703645",
          uiid: 10006,
          firstName: "john2",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e1e76921b815a703640",
          uiid: 10005,
          firstName: "balaji",
          lastName: "balaji",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400dcb76921b815a703623",
          uiid: 10004,
          firstName: "shiva",
          lastName: "shiva",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
      ],
    },
    _id: "d1db656619a3c376fc2eba73",
    uiid: 9999,
    firstName: "alba",
    lastName: "schimmel",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [147, 105],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "48badc21c9f801450c50cdba",
          uiid: 168,
          firstName: "garrick",
          lastName: "block",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "7b3362711b0084d5e27ff5c2",
          uiid: 113,
          firstName: "norene",
          lastName: "wolff-stiedemann",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "48fe31ae9f9456fd62fb91a3",
          uiid: 9995,
          firstName: "craig",
          lastName: "blick",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          _id: "baff1124a54b200be606beb0",
          uiid: 10000,
          firstName: "margaret",
          lastName: "mraz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e6276921b815a703651",
          uiid: 10010,
          firstName: "john6",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e5976921b815a70364e",
          uiid: 10009,
          firstName: "john5",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e4e76921b815a70364b",
          uiid: 10008,
          firstName: "john4",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e4176921b815a703648",
          uiid: 10007,
          firstName: "john3",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e3676921b815a703645",
          uiid: 10006,
          firstName: "john2",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e1e76921b815a703640",
          uiid: 10005,
          firstName: "balaji",
          lastName: "balaji",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400dcb76921b815a703623",
          uiid: 10004,
          firstName: "shiva",
          lastName: "shiva",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e6276921b815a703651",
          uiid: 10010,
          firstName: "john6",
          lastName: "doe",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "68400e5976921b815a70364e",
          uiid: 10009,
          firstName: "john5",
          lastName: "doe",
          employmentType: 2,
        },
      ],
    },
    _id: "95e7acdbfff4b747d750e8e1",
    uiid: 9998,
    firstName: "howell",
    lastName: "moore",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "683ac70f65e030001d60551c",
                uiid: 10001,
                firstName: "shiva",
                lastName: "shiva",
                employmentType: 2,
              },
              {
                _id: "da3238936e6be53433c38ef9",
                uiid: 20,
                firstName: "noemie",
                lastName: "corwin",
                employmentType: 3,
              },
            ],
          },
          _id: "7d15bf207bb814733276797b",
          uiid: 1,
          firstName: "gerhard",
          lastName: "schoen",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840279634e9d786acbe770e",
          uiid: 10011,
          firstName: "ss",
          lastName: "ss",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "6840301634e9d786acbe7748",
          uiid: 10012,
          firstName: "shiva",
          lastName: "skkk",
          employmentType: 2,
        },
      ],
    },
    _id: "93865666c9fe20e28a1ea023",
    uiid: 9992,
    firstName: "ervin",
    lastName: "fisher",
    employmentType: 2,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [175, 152],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
      ],
    },
    _id: "12784946e69517114e13bb24",
    uiid: 9991,
    firstName: "darien",
    lastName: "rice",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [125, 134],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d23692c20dcda02f295c668d",
                uiid: 43,
                firstName: "marianne",
                lastName: "block",
                employmentType: 1,
              },
              {
                _id: "0d3083a7e83c82a2db86a2e9",
                uiid: 86,
                firstName: "enrico",
                lastName: "stark",
                employmentType: 3,
              },
            ],
          },
          _id: "b19f2f23b047d4d2cd036d29",
          uiid: 105,
          firstName: "lurline",
          lastName: "gerhold",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "09f56033fe01eca634921849",
          uiid: 9983,
          firstName: "cyrus",
          lastName: "cole",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
      ],
    },
    _id: "a3071f682e4f346bc0cfa7e2",
    uiid: 9990,
    firstName: "dannie",
    lastName: "kuhic",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [106],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "09f56033fe01eca634921849",
          uiid: 9983,
          firstName: "cyrus",
          lastName: "cole",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "09f56033fe01eca634921849",
          uiid: 9983,
          firstName: "cyrus",
          lastName: "cole",
          employmentType: 2,
        },
      ],
    },
    _id: "584087dccc9869e44cfacc49",
    uiid: 9987,
    firstName: "benjamin",
    lastName: "goyette",
    employmentType: 2,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [161, 167],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "e6ee59c74553003199182dad",
          uiid: 200,
          firstName: "guadalupe",
          lastName: "torp",
          employmentType: 3,
        },
      ],
    },
    _id: "3e910f3e7f8eae95ff1fe722",
    uiid: 9984,
    firstName: "antonia",
    lastName: "rosenbaum",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [197, 130],
      approverTo: [],
    },
    _id: "28d2a740d4e0c3dbb9d2af09",
    uiid: 9982,
    firstName: "buford",
    lastName: "crooks",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [],
    },
    _id: "e89f66085aef1cfa0f56d4b8",
    uiid: 9980,
    firstName: "dessie",
    lastName: "grant",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "b70e3b79b77e43841011b6f4",
          uiid: 186,
          firstName: "javon",
          lastName: "mueller",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "d00ec45e26abc58bc38761d6",
          uiid: 158,
          firstName: "rosemarie",
          lastName: "considine",
          employmentType: 2,
        },
      ],
    },
    _id: "106c7fbdb8e47c1a34e0bdab",
    uiid: 9979,
    firstName: "austin",
    lastName: "o'hara",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [158],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "505d24aac466abe46a000cd1",
          uiid: 130,
          firstName: "eloisa",
          lastName: "schimmel",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "80e4f75ef54478d2d3e7d1c8",
          uiid: 170,
          firstName: "cleve",
          lastName: "howell",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "48fe31ae9f9456fd62fb91a3",
          uiid: 9995,
          firstName: "craig",
          lastName: "blick",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "7b0ca2846d31426c51529190",
          uiid: 9993,
          firstName: "heath",
          lastName: "maggio",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "c45a42c894e6b151af8d9cf0",
          uiid: 9989,
          firstName: "oral",
          lastName: "bahringer",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "db1c8206154847d8455914a1",
          uiid: 9988,
          firstName: "sheila",
          lastName: "skiles",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "7bea787c21ee76d201118177",
          uiid: 9985,
          firstName: "dudley",
          lastName: "lind",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "09f56033fe01eca634921849",
          uiid: 9983,
          firstName: "cyrus",
          lastName: "cole",
          employmentType: 2,
        },
      ],
    },
    _id: "58cfea7325c9330679502162",
    uiid: 9978,
    firstName: "meggie",
    lastName: "homenick",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [187, 197],
      approverTo: [],
    },
    _id: "8d56ef1c3b699654afbae445",
    uiid: 9977,
    firstName: "immanuel",
    lastName: "nienow-willms",
    employmentType: 2,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [118],
      approverTo: [
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "64f8c6df9e67d6cd61a6d23c",
          uiid: 9997,
          firstName: "dora",
          lastName: "wolf",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f6ed8e1933e63b654a84f86e",
          uiid: 9996,
          firstName: "eldora",
          lastName: "smitham",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "48fe31ae9f9456fd62fb91a3",
          uiid: 9995,
          firstName: "craig",
          lastName: "blick",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "f4f2b7032b713c351dfbf3da",
          uiid: 9994,
          firstName: "georgiana",
          lastName: "metz",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "7b0ca2846d31426c51529190",
          uiid: 9993,
          firstName: "heath",
          lastName: "maggio",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "c45a42c894e6b151af8d9cf0",
          uiid: 9989,
          firstName: "oral",
          lastName: "bahringer",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "db1c8206154847d8455914a1",
          uiid: 9988,
          firstName: "sheila",
          lastName: "skiles",
          employmentType: 2,
        },
        {
          approvalFlow: {
            approvers: [
              {
                _id: "d1db656619a3c376fc2eba73",
                uiid: 9999,
                firstName: "alba",
                lastName: "schimmel",
                employmentType: 3,
              },
            ],
          },
          _id: "830f2dd85bf9e477b954877e",
          uiid: 9986,
          firstName: "edward",
          lastName: "romaguera",
          employmentType: 3,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "7bea787c21ee76d201118177",
          uiid: 9985,
          firstName: "dudley",
          lastName: "lind",
          employmentType: 1,
        },
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "09f56033fe01eca634921849",
          uiid: 9983,
          firstName: "cyrus",
          lastName: "cole",
          employmentType: 2,
        },
      ],
    },
    _id: "031e229df61a244c4c82c479",
    uiid: 9976,
    firstName: "vance",
    lastName: "hoppe",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [
        {
          approvalFlow: {
            approvers: [],
          },
          _id: "e6ee59c74553003199182dad",
          uiid: 200,
          firstName: "guadalupe",
          lastName: "torp",
          employmentType: 3,
        },
      ],
    },
    _id: "c17d7a23c167792623f86991",
    uiid: 9975,
    firstName: "eladio",
    lastName: "hamill",
    employmentType: 1,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [],
      approverTo: [],
    },
    _id: "6625c2b5bc90bd2e29c28db5",
    uiid: 9974,
    firstName: "liam",
    lastName: "schultz",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [105],
      approverTo: [],
    },
    _id: "fd846f7d53403897b859575c",
    uiid: 9973,
    firstName: "terence",
    lastName: "corkery",
    employmentType: 3,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [127, 132],
      approverTo: [],
    },
    _id: "0bc90fe3b9ec51c7dcaf08b6",
    uiid: 9971,
    firstName: "reymundo",
    lastName: "rath",
    employmentType: 1,
  },
  {
    approvalFlow: {
      approvers: [],
      delegatedTo: [156, 151],
      approverTo: [],
    },
    _id: "0b397a6dc6627da6d0cabca6",
    uiid: 9970,
    firstName: "vergie",
    lastName: "ledner",
    employmentType: 1,
  },
];

const AccordianL1 = () => {
  //need Title uiid, firstName,  lastName
  //   {
  //     title: uiid, firstName,  lastName,
  //     content:"adsf",
  //   },
  const filtredData = data.map((item) => {
    return {
      title: item.uiid + " " + item.firstName + " " + item.lastName,
      content: <AccrdianL1Tabledata data={data} id={item.uiid} />,
    };
  });

  return (
    <div>
      <AccordianNew
        size="xs-sm"
        fullWidth={false}
        openDefault={null}
        data={filtredData}
        icon="keyboard_arrow_down"
        iconPosition="right"
      />
    </div>
  );
};

export default AccordianL1;
